module.exports = __webpack_public_path__ + "static/img/华为 HUAWEI Mate 70 Pro.2ac7f4cb.png";